import { Events } from '../tracking-events/event';
import { TrackEvent, TrackingTool } from '../tracking-tool';
import { TrackingProperties } from '../use-tracking';

export class LoggingTrackingTool implements TrackingTool {
  async turnOff() {
    console.info('Turned off tracking');
  }

  async turnOn() {
    console.info('Turned on tracking');
  }

  getName(): string {
    return 'logging-tracking-tool';
  }

  async trackEvent({ category, action, label, customData }: TrackEvent) {
    console.info(`Event: ${category} | ${action} | ${label}`, customData);
  }

  async trackCommonEvent(event: Events, properties?: TrackingProperties) {
    console.info({ ...event, ...properties });
  }
}
